<template>
  <el-dialog
    :title="`搜索批量标注记录 - ${fieldDetail.title}`"
    :visible.sync="visible"
    width="560px"
    :before-close="() => (visible = false)"
  >
    <div class="batch-history-modal">
      <el-table :data="list" max-height="600">
        <el-table-column prop="date" label="时间" />
        <el-table-column prop="filterText" label="搜索关键词" />
        <el-table-column prop="num" label="标注数" />
        <el-table-column label="" width="120">
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.disabled"
              :loading="scope.row.loading"
              @click.native.prevent="resetHandle(scope.row)"
              type="text"
              size="small"
            >
              <span>撤销标注</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs';
import converter from '@/lib/converter';
import { services } from '@/service';

export default {
  data() {
    return {
      loading: false,
      isReset: false,
      list: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: String,
      required: true
    },
    fieldDetail: {
      type: Object,
      required: true
    },
    historyList: {
      type: Array,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (this.loading) {
          this.$emit('正在撤销中，请稍候...');
          return;
        }
        if (this.isReset) {
          this.$emit('success');
        }
        this.$emit('update:show', val);
      }
    }
  },
  async mounted() {
    const paragraphArr = await services.labelRelation.getParagraph(this.courseId);
    this.list = this.historyList.map(item => {
      const textFilter = JSON.parse(item._source.textFilter || '[]');
      const textArr = [];
      textFilter.forEach(filterItem => {
        textArr.push(converter.toTip(filterItem, paragraphArr));
      });
      return {
        _id: item._id,
        date: dayjs(item._source.createTime).format('YYYY-MM-DD HH:mm:ss'),
        filterText: textArr.join('、'),
        num: item._source.total,
        disabled: item._source.status === 'reset',
        loading: false
      };
    });
  },
  methods: {
    async resetHandle(row) {
      if (this.loading) {
        this.$emit('正在撤销中，请稍候...');
        return;
      }
      await this.$confirm(`确定要撤销标注吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        row.loading = true;
        this.loading = true;
        await services.caseRule.fieldReset({
          taskId: row._id,
          coursewareId: this.courseId,
          labelId: this.fieldDetail.columnKey
        });
        row.loading = false;
        row.disabled = true;
        this.loading = false;
        this.isReset = true;
        this.$message.success('撤销成功。');
      } catch (err) {
        row.loading = false;
        this.loading = false;
        this.$error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.batch-history-modal {
}
</style>
